module.exports = __webpack_public_path__ + "static/img/icon-authorisation-completed.034e6f0c.svg";